export default "__VITE_ASSET__DtmXI1xn__"